module.exports = __webpack_public_path__ + "static/media/1POLICY44.171b072c.jpg";